import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-daily-facts-pagination',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './daily-facts-pagination.component.html',
  styleUrl: './daily-facts-pagination.component.scss',
})
export class DailyFactsPaginationComponent {
  page = input.required<number>();
  pageSize = input.required<number>();
  totalCount = input.required<number>();
  isLoading = input<boolean>(false);

  pageChange = output<number>();

  get totalPages(): number {
    return Math.ceil(this.totalCount() / this.pageSize()) || 1;
  }

  get from(): number {
    return this.page() * this.pageSize() + 1;
  }

  get to(): number {
    const to = (this.page() + 1) * this.pageSize();
    return to > this.totalCount() ? this.totalCount() : to;
  }

  goToPage(p: number): void {
    const clamped = Math.max(0, Math.min(p, this.totalPages - 1));
    this.pageChange.emit(clamped);
  }
}
